import { fromJS } from 'immutable';
import { createActions } from 'redux-actions';
import { normalize } from 'normalizr';
import { API } from 'aws-amplify';

import * as t from './actionTypes';
import * as schema from './schema';
import { getApp } from './selectors';
import misc from '../misc';

const actionCreators = createActions({
  [t.ENTITIES_ADD]: [entities => entities, () => ({ updatedAt: Date.now() })],
  [t.NETWORK_START]: undefined,
  [t.NETWORK_RESET]: undefined,
  [t.NETWORK_ERROR]: undefined,
  [t.ACTIVE_SET]: undefined
});

/**
 * Fetch records from API
 */
export const fetchSessions = () => async dispatch => {
  dispatch(actionCreators.sessions.networkStart());
  let res;
  try {
    res = await API.get('ptapp', '/sessions');
  } catch (e) {
    dispatch(actionCreators.sessions.networkError(e.message));
    return;
  }
  const data = normalize(res, schema.sessionList);
  dispatch(actionCreators.sessions.entitiesAdd(fromJS(data.entities.sessions)));
  dispatch(actionCreators.sessions.networkReset());
};

/**
 * Fetch records from API if cache has expired
 */
export const fetchSessionsIfNeeded = () => async (dispatch, getState) => {
  const app = getApp(getState());
  const lastUpdate = app && app.get('lastUpdate');
  const cacheTime = Date.now() - lastUpdate;
  if (lastUpdate === null || cacheTime > 60000 * 5) {
    // 5 minute cache
    fetchSessions()(dispatch);
  }
};

/**
 * Update record through API
 * @param  {string} id      The id to update, or undefined
 * @param  {object} values  New values for record
 * @param  {object} history react-router-dom history
 */
export const submitSessionEdit = (id, values, history) => async dispatch => {
  dispatch(actionCreators.sessions.networkStart());
  const payload = {
    body: {
      startsAt: values.get('startsAt'),
      duration: values.get('duration'),
      recurs: values.get('recurs'),
      locationId: values.get('locationId'),
      clientIds: values.get('clientIds').toJS()
    }
  };
  try {
    let res;
    if (typeof id === 'undefined') {
      res = await API.post('ptapp', '/sessions', payload);
      id = res.id;
    } else {
      res = await API.put('ptapp', `/sessions/${id}`, payload);
    }
    const data = normalize(res, schema.session);
    dispatch(
      actionCreators.sessions.entitiesAdd(fromJS(data.entities.sessions))
    );
  } catch (e) {
    dispatch(actionCreators.sessions.networkReset());
    misc.lib.throwSubmissionErrorFromAxiosError(e);
  }

  dispatch(actionCreators.sessions.activeSet(id));
  history.push('/sessions/' + id);
  dispatch(actionCreators.sessions.networkReset());
};

/**
 * Set active record
 * @param {string} id The ID of the record to set as active
 */
export const setActive = id => async dispatch => {
  dispatch(actionCreators.sessions.activeSet(id));
};



// WEBPACK FOOTER //
// ./src/modules/sessions/actions.js